import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e89497c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "campaign-complete-info-header" }
const _hoisted_2 = { id: "campaign-complete-info-header-title" }
const _hoisted_3 = ["data-wallet"]

import { Claim } from '@/common/extensionContracts/claimExtensionContract';
import { isExclusiveClaim, isUnlimitedSupply } from '@/lib/claimUtil';

interface ClaimProps {
  claimConfig: any;
  claim: Claim;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimSummary',
  props: {
    claimConfig: {},
    claim: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.claimConfig?.name), 1),
    _createElementVNode("div", {
      id: "campaign-complete-info-header-artist",
      "data-widget": "m-wallet-identity",
      class: "manifold-scheme-light",
      "data-wallet": _ctx.claimConfig?.creator.address
    }, null, 8, _hoisted_3)
  ]))
}
}

})